var map = {
	".": "eRNY",
	"./": "eRNY",
	"./01_connect": "lyY+",
	"./01_connect.json": "lyY+",
	"./02_data_compress": "Q5Jp",
	"./02_data_compress.json": "Q5Jp",
	"./03_heart_beat": "IMXD",
	"./03_heart_beat.json": "IMXD",
	"./04_subscribe": "rEmz",
	"./04_subscribe.json": "rEmz",
	"./05_cancel_subscribe": "SBKE",
	"./05_cancel_subscribe.json": "SBKE",
	"./index": "eRNY",
	"./index.js": "eRNY"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NXdJ";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/cswap/websocket/introduce ^.*$
// module id = NXdJ
// module chunks = 3